import {Routes} from '@angular/router'
import {HomeComponent} from './home/home.component'

export default [
  {
    path: '',
    component: HomeComponent
  }
] satisfies Routes
